import React, { useEffect, useState } from "react";
import { Transition } from "react-transition-group";

const duration = 200;

const defaultStyle = {
  transition: `all ${duration}ms ease-in-out`,
  opacity: 0,
  transform: `translateY(-10%)`,
  marginTop: 8,
  marginBottom: 40,
};

const transitionStyles = {
  appear: { opacity: 1, transform: `translateY(0)` },
  entering: { opacity: 1, transform: `translateY(0)` },
  entered: { opacity: 1, transform: `translateY(0)` },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

function TransitionComponent({ children, style }) {
  const [inProp, setInProp] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setInProp(true);
    }, 500);
  }, [inProp, setInProp]);

  const nodeRef = React.useRef(null);

  return (
    <>
      <Transition in={inProp} timeout={duration} nodeRef={nodeRef}>
        {(state) => (
          <div
            style={{
              ...defaultStyle,
              ...style,
              ...transitionStyles[state],
            }}
          >
            {children}
          </div>
        )}
      </Transition>
    </>
  );
}

export default TransitionComponent;
